import React from 'react';
import ReloadButton from '../../../features/ReloadButton/ReloadButton';
import { InputFieldSearch, SelectOption, addOption } from '../../../utils/InputField';
import { useApiPage } from '../ApiPageProvider';

function PageHeaderLeftCol({ handleChangeFilterData, p }) {
    return (
        <form
            // onSubmit={handleOnEnter}
            className="customers_page_header_left_col flex-1 flex flex-row items-center gap-x-2 md:gap-x-4"
        >
            <InputFieldSearch
                label="Search"
                name="q"
                onChange={handleChangeFilterData}
                formData={p}
                className="w-72 rounded-xl"
            />

            <SelectOption
                name="method"
                placeholder="Http Method"
                formData={p}
                onChange={handleChangeFilterData}
                options={['Get', 'Post', 'Put', 'Patch', 'Delete']?.map((d) =>
                    addOption(d, d, d?.toLowerCase())
                )}
                className="w-44 rounded-xl"
            />
        </form>
    );
}

function PageHeaderRightCol() {
    const { handleReload } = useApiPage();
    return (
        <div className="customer_page_header_right_col flex-1 flex flex-row gap-2 justify-end items-center w-">
            <ReloadButton height="h-10" width="w-10" onClick={handleReload} />
        </div>
    );
}

function ApiPageHeader({ handleChangeFilterData, p }) {
    return (
        <div className="customer_page_header w-full mb-3 md:mb-7 flex flex-row justify-between items-center">
            <PageHeaderLeftCol handleChangeFilterData={handleChangeFilterData} p={p} />
            <PageHeaderRightCol />
        </div>
    );
}

export default ApiPageHeader;
